import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"
import { TApiTasksFilters } from "../../api-client/tasks-api"
import { TApiProjectSection } from "../../api-client/types"
import { useProjectSectionTasksQuery } from "./use-project-section-tasks-query"
import { clone, cloneDeep } from "lodash"
import { act } from "react-dom/test-utils"

interface Args {
  oldSectionId: string
  newSectionId: string
  taskId: string
  position: number
  //index: number
  //prevSectionId: string
}

interface Params {
  projectId: string
  filters?: TApiTasksFilters
}

export function useUpdateTaskSectionMutation(params: Params) {
  const {
    projectId,
    filters
  } = params

  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["update-task-section"],
    async (args: Args) => {
      const {
        position,
        oldSectionId,
        newSectionId,
        taskId,
      } = args

      // TODO: push filters here
      const oldSectionPages = queryClient.getQueryData(["project-section-tasks", projectId, oldSectionId, filters])

      console.warn('SECTIONS', ["project-section-tasks", projectId, newSectionId, filters])
      console.warn(oldSectionPages)

      let activeTask = findTaskById(oldSectionPages, taskId)
      if (!activeTask) console.error(`Can not find task with given id ${taskId} in project sections!`)

      //console.log('SECTIONS', ["project-section-tasks", projectId, newSectionId, filters])
      //console.log(oldSectionPages)

      console.warn("ACTIVE TASK")
      console.warn(activeTask)

      const newSectionPages = queryClient.getQueryData(["project-section-tasks", projectId, newSectionId, filters])

      console.warn('NEW PAGES')
      console.warn(newSectionPages)

      // Remove item from old section
      queryClient.setQueryData(["project-section-tasks", projectId, oldSectionId, filters], (old: any) => {
        const newPages = cloneDeep(old)

        const existingTask = newPages.pages[0].tasks.find((t) => t.id == activeTask.id)

        if (existingTask) {
          // assign new projectSectionId to the moved task to reflect the local change
          newPages.pages[0].tasks.splice(newPages.pages[0].tasks.indexOf(existingTask), 1)
          return newPages
        }

        return old
      })


      // Add item to the new section
      queryClient.setQueryData(["project-section-tasks", projectId, newSectionId, filters], (old: any) => {
        const newPages = cloneDeep(old)

        if (!newPages.pages[0].tasks.find((t) => t.id == activeTask.id)) {

          // Ensure its a local copy and has project section id updated locally
          const taskInstanceInNewSection = cloneDeep(activeTask)
          taskInstanceInNewSection.projectSectionId = newSectionId

          newPages.pages[0].tasks.unshift(taskInstanceInNewSection)
          return newPages
        }

        return old
      })



      /*
      const response = await apiClient.updateTasksWithDifferentSections(
        projectId,
        sectionId,
        position,
        id,
        prevSectionId
      )

      if (!response.ok) {
        throw response.errors
      }
      */

      return true
    },
    {
      onMutateOLD: async (data: Args) => {
        let task

        queryClient.setQueryData(
          ["board-tasks", data.projectId, data.prevSectionId],
          (old: { pages: ProjectSection[] }) => {
            const newPages = { pages: [] }

            old.pages.forEach((item) => {
              const tasks = []
              item.tasks.forEach((el) => {
                if (el.id !== data.id) {
                  tasks.push(el)
                } else {
                  task = el
                }
              })
              newPages.pages.push({ ...item, tasks: tasks })
            })

            return newPages
          }
        )

        queryClient.setQueryData(
          ["board-tasks", data.projectId, data.sectionId],
          (old: { pages: ProjectSection[] }) => {
            const pageIndex = Math.floor(data.position / 10)
            task.position = data.position
            old.pages[pageIndex].tasks.splice(data.index, 0, task)
            return old
          }
        )

        return data
      },
      onSuccessOLD: (data, vars) => {
        queryClient.invalidateQueries([
          "board-tasks",
          vars.projectId,
          vars.prevSectionId,
        ])
        queryClient.invalidateQueries([
          "board-tasks",
          vars.projectId,
          vars.sectionId,
        ])
      },
      // onSettled: (data, vars) => {
      //   queryClient.invalidateQueries([
      //     "board-tasks",
      //     vars.projectId,
      //     vars.prevSectionId,
      //   ])
      //   queryClient.invalidateQueries([
      //     "board-tasks",
      //     vars.projectId,
      //     vars.sectionId,
      //   ])
      // },
      onErrorOLD: (
        error,
        newOrder,
        context: { previousState: ProjectSection[] }
      ) => {
        queryClient.setQueryData(
          ["board-tasks", newOrder.projectId],
          context.previousState
        )
      },
    }
  )

  return mutation
}


function findTaskById(sections: any, taskId: string) {
  for (const page of sections.pages) {
    for (const task of page.tasks) {
      if (task.id === taskId) {
        return task
      }
    }
  }
  return undefined
}

